var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.2808 21.1694L18.0228 16.1222C19.2622 14.5861 19.9513 12.689 19.9513 10.7153C19.9513 8.34363 18.9563 6.08258 17.2073 4.42559C15.4603 2.77061 13.1036 1.85098 10.6585 1.85098C9.4465 1.85098 8.24506 2.07706 7.12226 2.51767C5.99938 2.9583 4.97521 3.60564 4.10971 4.42559C3.24407 5.24567 2.55389 6.22263 2.08178 7.30243C1.60958 8.38241 1.36563 9.54229 1.36563 10.7153C1.36563 11.8882 1.60958 13.0481 2.08178 14.1281C2.55389 15.2079 3.24407 16.1849 4.10971 17.0049C4.97521 17.8249 5.99938 18.4722 7.12226 18.9129C8.24506 19.3535 9.4465 19.5795 10.6585 19.5795C12.728 19.5795 14.7341 18.9208 16.3608 17.715L21.688 22.8287L23.2808 21.1694Z",
    stroke: "#A69797",
    strokeWidth: 2.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchMobile);
export default __webpack_public_path__ + "static/media/search-mobile.a2328ad316fb5be630550de447edf50e.svg";
export { ForwardRef as ReactComponent };